import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import css from '../styles/home-testimonials.css';

const { Component } = React;

class Testimonials extends Component {
  render() {
    let { quotes } = this.props;
    quotes = quotes.slice(0,3);

    return (
      <div className="home-testimonials clearfix">
        <div className="home-testimonials__image">
        </div>
        <div className="home-testimonials__info">
          {quotes.map((quote, i) => <Quote quote={quote} key={i} />)}
        </div>
        <Link className="home-testimonials__link bfm-link" to="/testimonials">More</Link>
      </div>
    );
  }
}

class Quote extends Component {
  render() {
    return (
      <div className="home-testimonials__quote" data-aos="zoom-in">
        {this.props.quote.text.map((line, i) => <p>&quot;{line}&quot;</p> )}
        <em>- {this.props.quote.author}</em>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    quotes: state.testimonials
  };
}

function mapDispatchToProps(dispatch) {
  return {};
}

let TestimonialsContainer = connect(mapStateToProps, mapDispatchToProps)(Testimonials);

export { Testimonials, TestimonialsContainer };



// WEBPACK FOOTER //
// ./app/screens/App/screens/Home/components/home-testimonials.js